import components from "./components";
import pages from "./pages";

export default {
  pages,
  components,
};